<template>
  <div
    class='checkbox'
    :class='{ "has-error": localErrors.length, "disabled" : disabled }'
  >
    <input
      :id='id'
      type='checkbox'
      :value='value'
      :required='required'
      :disabled='disabled'
      :checked='checked'
      @change='updateValue'/>
    <label class='font-smoothing' v-if='label !== null' :for='id' v-html='label'></label>
    <x-errors-messages :errors='localErrors'></x-errors-messages>
  </div>
</template>

<script>
  import xErrorsMessages from './x-errors-messages'

  let checkboxId = 0

  export default {
    name: 'x-checkbox',

    components: {
      'x-errors-messages': xErrorsMessages
    },

    props: {
      value: {},

      checked: {
        type: Boolean,
        default: false
      },

      label: {
        type: String,
        default: null
      },

      required: {
        type: Boolean,
        default: false
      },

      disabled: {
        type: Boolean,
        default: false
      },

      errors: {
        type: Array,
        default: () => []
      }
    },

    data () {
      return {
        id: `x-checkbox-${checkboxId++}`,
        localErrors: []
      }
    },

    watch: {
      errors () {
        this.localErrors = this.errors
      }
    },

    methods: {
      updateValue (event) {
        this.localErrors = []
        this.$emit('update', this.value ? event.target.value : event.target.checked)
      }
    }
  }
</script>

<style lang='scss' scoped rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  $checkbox-width: 2rem;

  .checkbox {
    position: relative;
    cursor: pointer;
  }

  input {
    margin: 0;
    padding: 0;
    appearance: none;
    cursor: pointer;
  }

  label {
    cursor: pointer;
  }

  input:focus {
    outline: 0;
  }

  .has-error {
    input {
      border-color: $color-red;
    }

    label {
      color: $color-red;
    }
  }

  .errors-messages {
    padding: 0.6rem 1.4rem;
    font-size: 1.4rem;
  }

  // Classic checkbox

  .checkbox:not(.slider) {
    display: inline-flex;
    align-items: center;

    &:before {
      content: '';
      position: absolute;
      z-index: 1;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      background-image: url('~@/assets/icn-checked.svg');
      background-size: $checkbox-width*0.75;
      background-repeat: no-repeat;
      background-position: center center;
      height: $checkbox-width;
      width: $checkbox-width;
    }

    label {
      display: block;
      padding: $space-small $space-small $space-small $space-big;
      font-size: 1.4rem;
      font-weight: 600;
      color: $color-daddy;
      z-index: 2;
    }

    input {
      width: $checkbox-width;
      height: $checkbox-width;
      border-radius: 2px;
      background-color: white;
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      border: 1px solid $color-ghost;
    }

    input:disabled {
      background-color: $color-whisper;
    }

    input:checked {
      background-color: map_get($palette-primary, main);
      border-color: map_get($palette-primary, main);
    }
  }

  // Slider checkbox

  .checkbox.slider {
    display: inline-block;

    label {
      display: inline-block;
      font-size: 0;
      width: 6rem;
      padding: 0;
      height: 2.8rem;
      border-radius: 2rem;
      transition: background 120ms ease-in-out, border 120ms ease-in-out;
      border: 2px solid;
      background-color: $color-ghost;
      border-color: $color-ghost;
    }

    input {
      position: absolute;
      background-color: white;
      border-radius: 100%;
      height: 2.4rem;
      width: 2.4rem;
      top: 0.2rem;
      left: 0.2rem;
      transition: transform 120ms ease-in-out;
    }

    input:checked {
      transform: translateX(3.2rem);

      + label {
        background-color: map_get($palette-primary, main);
        border-color: map_get($palette-primary, main);
      }
    }

    &.disabled {
      opacity: 0.2;
      pointer-events: none;
    }

    &.switch {
      input {
        height: 9rem;
        width: 9rem;
        top: 0.5rem;
        left: 0.5rem;

        &:checked {
          left: auto;
          right: 0.5rem;
          transform: none;
        }
      }

      label {
        width: 25rem;
        height: 10rem;
        border-radius: 10rem;
      }
    }
  }
</style>
